
    import './styles.scoped.css';
    export default {
  "button-dropdown": "awsui_button-dropdown_sne0l_nfcqc_93",
  "items-list-container": "awsui_items-list-container_sne0l_nfcqc_97",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_sne0l_nfcqc_1",
  "rotate-up": "awsui_rotate-up_sne0l_nfcqc_116",
  "rotate-down": "awsui_rotate-down_sne0l_nfcqc_131",
  "header": "awsui_header_sne0l_nfcqc_146",
  "title": "awsui_title_sne0l_nfcqc_157",
  "description": "awsui_description_sne0l_nfcqc_158",
  "split-trigger-wrapper": "awsui_split-trigger-wrapper_sne0l_nfcqc_162",
  "trigger-item": "awsui_trigger-item_sne0l_nfcqc_165",
  "trigger-button": "awsui_trigger-button_sne0l_nfcqc_168",
  "visual-refresh": "awsui_visual-refresh_sne0l_nfcqc_179",
  "split-trigger": "awsui_split-trigger_sne0l_nfcqc_162",
  "dropdown-trigger": "awsui_dropdown-trigger_sne0l_nfcqc_187",
  "test-utils-button-trigger": "awsui_test-utils-button-trigger_sne0l_nfcqc_191"
};
  